import estateHttp from "@/services/http/estate.http";
import {useHttp} from "@/composable/service/useHttp";

export default function useGetImages() {
  const http = useHttp(estateHttp.checkImageExists);

  // TODO RETURN A OBJECT URL
  async function checkImageSizes(url: string, fallbackSrc = 'noimg_l.jpg') {
    const largeImageUrl = isImageUrlLarge(url) ? url : changeImageSize(url);
    const smallImageUrl = isImageUrlLarge(url) ? changeImageSize(url) : url;
    if (await http.request(largeImageUrl)) return largeImageUrl;
    if (await http.request(smallImageUrl)) return smallImageUrl;
    return new URL(`/src/assets/img/${fallbackSrc}`, import.meta.url).href;
  }

  function changeImageSize(url: string) {
    return url.replace(/L?(\.\w+)$/, (match, ext) => (match.includes("L") ? ext : `L${ext}`));
  }

  function isImageUrlLarge(url: string) {
    return /L\.\w+$/.test(url);
  }

  return {
    request: checkImageSizes,
    loading: http.loading,
    error: http.error
  }
}
